export enum SERVICEBASEURL {
	BACKEND = '/backend',
	AI = '/ai',
	TRACING = '/tracenet',
	USER = '/user',
	DATA = '/data',
	REPORT = '/foodreport',
}
